import { BaseState } from '../types';

// Actions

export enum StatementTypes {
  FetchListRequest = '@statements/LIST_REQUEST',
  FetchListSuccess = '@statements/LIST_SUCCESS',
  FetchListFailure = '@statements/FAILURE',
  ListReset = '@statements/LIST_UPDATE',
}

// Response

export enum ReportType {
  All = 'All',
  In = 'In',
  Out = 'Out',
}

export interface PersonalInfo {
  Document: string;
  Name: string;
  AgencyNumber: string;
  AgencyDigit: string;
  AccountNumber: string;
  AccountDigit: string;
}

export type TransferTypeTyping = 'SPB' | 'PIX' | 'INT';

export type OperationTypeTyping =
  | 'WITHDRAW'
  | 'DEPOSIT'
  | 'BUYING_CURRENCY'
  | 'SELLING_CURRENCY';

export type StatementDescription =
  | 'EXCHANGE'
  | 'WITHDRAW'
  | 'WITHDRAW(REVERTED)'
  | 'DEPOSIT';

export interface Statement {
  Id: number;
  Date: string;
  Description: StatementDescription;
  TransactionId: string;
  StatusType: string;
  Amount: number;
  AmountFormatted?: string;
  Balance: number;
  BalanceFormatted?: string;
  Type: OperationTypeTyping;
  FullName: string;
  DocumentId: string;
  DocumentNumber: string;
  PayerBankCompe: string;
  PayerAgencyNumber: string;
  PayerAccountNumber: string;
  ReceiverBankCompe: string;
  ReceiverAgencyNumber: string;
  ReceiverAccountNumber: string;
  TransferType: TransferTypeTyping;
}

export interface FormattedStatement extends Statement {
  Hour: string;
  BalanceFormatted: string;
  AmountFormatted: string;
  PayerBankName: string;
  ReceiverBankName: string;
  PayerDocumentIdFormatted: string;
  ReceiverDocumentIdFormatted: string;
  TransferTypeFormatted: string;
  IsIncomingOperation: boolean;
  DescriptionLabel: string;
}

export type StatementList = Statement[];

export type FormattedStatementList = FormattedStatement[];

export interface StatementResponse {
  LastUpdated: string;
  PersonalInfo: PersonalInfo;
  PreviousDay: number;
  Records: FormattedStatementList;
  Total: number;
  BalanceLast: number;
  Update?: boolean;
}

export interface StatementRequestPayload {
  periodStart?: Date;
  periodEnd?: Date;
  reportType?: ReportType;
  document?: string;
  limit?: number;
  offset?: number;
  update?: boolean;
}

// State

export interface StatementState extends BaseState {
  readonly lastUpdated: string;
  readonly list: FormattedStatementList;
  readonly previousDayValue: number | string;
  readonly totalValue: number;
  readonly balanceLast: number;
  readonly isSuccess: boolean;
  readonly isStatementListFilled: boolean;
  readonly hasMore: boolean;
}
